import { getLocale } from '@/common/utils';

// Here we have the timezone already included as no need to worry about compatibility
export function formatTimestamp(timestamp: string): string {
  const instant = Temporal.Instant.from(timestamp);
  return instant.toLocaleString(getLocale(), {
    dateStyle: 'short',
    timeStyle: 'medium',
  });
}
